import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addNewExperience,
  fetchAllExperience,
  removeExperience,
} from "../../apis/partner";
import { useDispatch } from "react-redux";
import {
  addExperienceData,
  removeExperienceData,
} from "../../store/Partner/partnerDataSlice";

export const useFetchAllExperience = (partnerId) => {
  return useQuery({
    queryKey: ["experience"],
    queryFn: () => fetchAllExperience(partnerId),
  });
};

export const useAddExperience = (navigate) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: ({ partnerId, experienceData }) =>
      addNewExperience(partnerId, experienceData),
    onSuccess: (newExperience) => {
      // queryClient.setQueryData(["experience"], (oldData) => {
      //     console.log('Old Data: ', oldData);

      //     const newData = [...oldData, newExperience];
      //     return newData;
      // });
      dispatch(addExperienceData(newExperience));
      navigate("/dashboard/partner", { replace: true });
    },
    onError: (error) => {
      console.error(error);
    },
  });
};

export const useDeleteExperience = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: ({ partnerId, experienceId }) =>
      removeExperience(partnerId, experienceId),
    onSuccess: (deletedExperience) => {
      dispatch(removeExperienceData(deletedExperience));
    },
    onError: (error) => {
      console.error(error);
    },
  });
};
